import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Collapse from '@mui/material/Collapse'
import Paper from '@mui/material/Paper'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'

import { i18WithParams as t } from '@shared/locale'
import { useAdminPreRegValidation } from 'service-api/src/hooks/use_admin_prereg_validation'
import { dayToJSDate, formatOnlyDate } from 'components-ui'
import { CheckList } from './check_list'
import { checkCompliant, processPreRegValidation } from './helper'

export const Notification = ({ lupId }: { lupId: string }) => {
  const { accountName: locationName = '' } = useParams()
  const preRegValidation = useAdminPreRegValidation(locationName, lupId)
  const [isOpen, setIsOpen] = useState(true)

  const { regData, isPreRegCompliant } = useMemo(() => {
    if (preRegValidation.isSuccess) {
      return {
        regData: processPreRegValidation(preRegValidation.data),
        isPreRegCompliant: checkCompliant(preRegValidation.data),
      }
    }
    return { regData: null, isPreRegCompliant: true }
  }, [preRegValidation.data, preRegValidation.isSuccess])

  const handlePanel = () => setIsOpen((prevValue) => !prevValue)

  if (preRegValidation.isLoading) {
    return <Skeleton variant="rounded" width="100%" height={50} sx={{ mb: 3 }} />
  }

  if (isPreRegCompliant) {
    return null
  }

  let title = t('profile.notification.title')
  if (regData?.order) {
    const serviceType = regData.order.primaryServiceType?.displayName || ''
    const period = regData.order.invoices?.[0]?.period?.[0]?.startDate || ''
    title = t('profile.notification.titleWithOrder', { serviceType, date: formatOnlyDate(dayToJSDate(period)) })
  }

  return (
    <Paper elevation={1} sx={{ mb: 3 }}>
      <Box px={2} py={1} sx={{ backgroundColor: 'warning.shade12' }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
            <WarningAmberIcon color="warning" />
            <Typography variant="body1" color="warning.dark">
              {title}
            </Typography>
          </Stack>
          <Button variant="text" onClick={handlePanel} sx={{ color: 'warning.dark' }}>
            {t(isOpen ? 'profile.notification.button.hide' : 'profile.notification.button.show')}
          </Button>
        </Stack>
      </Box>
      <Collapse in={isOpen}>
        <Box p={2}>
          <CheckList regData={regData} useLinks={true} useIcons={false} />
        </Box>
      </Collapse>
    </Paper>
  )
}
